import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import objectFitImages from 'object-fit-images';

import { AnimateObserver } from './lib/animate-observer';

objectFitImages();

const animate = new AnimateObserver();
animate.init();
